var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[(_vm.type === 'stat-chart')?_c('div',{staticClass:"stat-chart",attrs:{"id":"stat-chart"}}):(_vm.type === 'rate-chart')?_c('div',{ref:"rate-chart",staticClass:"rate-chart"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }